import React from 'react';

import LEGENDA_POTASSIO from 'assets/customSubtitles/LEGENDA_POTASSIO.jpg';
import LEGENDA_RAZAO_eTh_K from 'assets/customSubtitles/LEGENDA_RAZAO_eTh_K.jpg';
import LEGENDA_ANOMALIA_BOUGUER from 'assets/customSubtitles/LEGENDA_ANOMALIA_BOUGUER.jpg';
import Legenda_RGB from 'assets/customSubtitles/Legenda_RGB.jpg';
import LEGENDA_DERIVADA_VERTICAL from 'assets/customSubtitles/LEGENDA_DERIVADA_VERTICAL.jpg';
import LEGENDA_ANOMALIA_MAGNETOMETRICA from 'assets/customSubtitles/LEGENDA_ANOMALIA_MAGNETOMETRICA.jpg';
import LEGENDA_CONTAGEM_TOTAL from 'assets/customSubtitles/LEGENDA_CONTAGEM_TOTAL.jpg';
import LEGENDA_eTORIO from 'assets/customSubtitles/LEGENDA_eTORIO.jpg';
import LEGENDA_eURANIOL from 'assets/customSubtitles/LEGENDA_eURANIOL.jpg';
import LEGENDA_GRADIENTE_TOTAL from 'assets/customSubtitles/LEGENDA_GRADIENTE_TOTAL.jpg';

export default [
  {
    layername: 'wms_geofisica_mag',
    icon: <img src={LEGENDA_ANOMALIA_MAGNETOMETRICA} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_1dv',
    icon: <img src={LEGENDA_DERIVADA_VERTICAL} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_ct',
    icon: <img src={LEGENDA_CONTAGEM_TOTAL} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_kperc',
    icon: <img src={LEGENDA_POTASSIO} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_ternario',
    icon: <img src={Legenda_RGB} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_thk',
    icon: <img src={LEGENDA_RAZAO_eTh_K} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_eth',
    icon: <img src={LEGENDA_eTORIO} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_equ',
    icon: <img src={LEGENDA_eURANIOL} className="customSubtitles" />,
  },
  {
    layername: 'wms_geofisica_anomalia_bouguer_brasil',
    icon: <img src={LEGENDA_ANOMALIA_BOUGUER} className="customSubtitles" />,
  },
  {
    layername: 'tif_grad_total',
    icon: <img src={LEGENDA_GRADIENTE_TOTAL} className="customSubtitles" />,
  },
];
